import { useEffect, useState } from "react";
import { Card, Container, Table } from "react-bootstrap";
import { useSearchParams } from "react-router-dom";
import Swal from "sweetalert2";
import { getMethod } from "../../function/helper";
import Loading from "../../modules/pages/newLetter/Loader";
import NavPills from "../../modules/public/slider/NavPills";
import SuccessShipmentBox from "../public/payResult/SuccessShipmentBox";

function TrackingGrid() {
  const [params] = useSearchParams();

  const orderId = params.get("id");

  const [state, setState] = useState({
    startNumber: 1,
    isLoading: false,
    item: undefined,
    trackingData: [],
  });

  const getResult = async () => {
    if (!orderId) {
      return;
    }

    setState(cur => ({ ...cur, isLoading: true }));
    const response = await getMethod(`/totalpost/v1/track/${orderId}`);
    setState(cur => ({ ...cur, isLoading: false }));

    if (response && response.status === 200) {
      setState(cur => ({
        ...cur,
        item: response.item,
        trackingData: response.track.history,
      }));
      return;
    }

    Swal.fire({
      icon: "error",
      text: response.message,
      showConfirmButton: true,
      confirmButtonText: "متوجه شدم",
      confirmButtonColor: "red",
    });
  };

  useEffect(() => {
    getResult();
  }, [params.get("id")]);

  const table = (
    <div className="rtl-all mt-4 d-flex justify-content-center">
      {state.item !== undefined && (
        <SuccessShipmentBox shipment={state.item} isTrack />
      )}
    </div>
  );

  const table2 = (
    <Card className="mt-4">
      <Card.Header
        style={{ backgroundColor: "#4b1483" }}
        className="text-white text-center"
      >
        نتایج جستجو و استعلام از سرویس دهنده
      </Card.Header>
      <div className="w-100 overflow-x-auto px-2 mt-3">
        <Table responsive striped bordered={true} dir="rtl">
          <thead>
            <tr>
              <th className="text-secondary">ردیف</th>
              <th className="text-secondary">تاریخ</th>
              <th className="text-secondary">ساعت</th>
              <th className="text-secondary">مکان</th>
              <th className="text-secondary">وضعیت</th>
              <th className="text-secondary">توضیحات</th>
            </tr>
          </thead>
          <tbody>
            {state.trackingData.map((item, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{item.localDate}</td>
                <td>{item.time}</td>
                <td>{item.location}</td>
                <td>{item.state}</td>
                <td>{item.comment}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </Card>
  );

  return (
    <div className="mt-5 mb-4">
      <Container className="rtl-all mb-6">
        <h3>رهگیری مرسوله</h3>
        <p>
          برای رهگیری آنی و آنلاین بسته های پستی و مرسولات خود می توانید از طریق
          باکس زیر اقدام کنید. در اینجا شماره سفارش یا بارکد پیامک شده را وارد
          نمایید تا از آخرین وضعیت مرسوله خود مطلع شوید.
        </p>
      </Container>

      <section className="pt-5">
        <NavPills />
      </section>

      {state.isLoading && <Loading />}
      {!state.isLoading && (
        <Container>
          {!!orderId && state.item && table}
          {!!orderId && state.item && table2}
        </Container>
      )}
    </div>
  );
}

export default TrackingGrid;
